export enum DocumentType {
  DEBT_CONSOLIDATION_FORM = "DEBT_CONSOLIDATION_FORM",
}

export interface ApplicationType {
  uuid: string;
  reference: string;
  modifiedOn: string;
  applicationDate: string;
  isLatestSubmission: boolean;
}

export interface CaseDocument {
  uuid: string;
  kind: string;
  kindLabel: string;
  name: string;
  createdOn: string;
}

export interface DocumentUploadType {
  type: DocumentType;
  label: string;
  description: string;
  maxFiles: number;
}

export type DocumentUploadStateType = {
  uploading: string | null;
  uploadError: Record<string, string | null>;
  documentsError: unknown;
};
